import CookieWallModalView from '../views/cookieWallModal.view.html';

class CookieWallController {
    constructor($scope, $uibModal) {
        'ngInject';

        this.$scope = $scope;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        this.detectCookies();
        window.addEventListener('showCookieWallModal', () => {
            this.openModal();
        });
    }

    openModal() {
        this.$uibModal.open({
            animation: 'false',
            size: 'lg',
            controller: CookieWallModalController,
            controllerAs: 'modal',
            template: CookieWallModalView,
            backdrop: 'static',
            keyboard: false,
            resolve: {}
        }).result.then(() => {});
    }

    closeModal() {
        this.$uibModal.close();
    }

    detectCookies() {
        let isSet = this.getCookie('acceptCookies');
        if (!isSet) {
            this.openModal();
        }
    }

    getCookie(cname) {
        let name = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}

class CookieWallModalController {
    constructor($scope, $uibModalInstance) {
        'ngInject';

        this.$scope = $scope;

        this.cookie_1 = true;

        let acceptCookies = this.getCookie('acceptCookies');
        console.log(acceptCookies);
        if (acceptCookies === '1') {
            this.cookie_2 = true;
            this.cookie_3 = true;
        } else if (acceptCookies === '2') {
            this.cookie_2 = true;
        } else if (acceptCookies === '3') {
            this.cookie_3 = true;
        } else {
            this.cookie_2 = false;
            this.cookie_3 = false;
        }

        this.showMoreCookieInfo = false;
        this.showMoreCookieDetails = false;

        this.$uibModalInstance = $uibModalInstance;
    }

    acceptCookies() {
        this.setCookie('acceptCookies', '1', 30);
        this.closeModal();
    }

    acceptSomeCookies() {
        if (this.cookie_2 && this.cookie_3) {
            this.setCookie('acceptCookies', '1', 30);
        } else if (this.cookie_2) {
            this.setCookie('acceptCookies', '2', 30);
        } else if (this.cookie_3) {
            this.setCookie('acceptCookies', '3', 30);
        } else {
            this.setCookie('acceptCookies', '4', 30);
        }
        this.closeModal();
    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

        if (cname !== 'acceptCookies') {
            return;
        }

        let consent = {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        };

        if (cvalue === '1' || cvalue === '2') {
            consent.analytics_storage = 'granted';
        }

        if (cvalue === '1' || cvalue === '3') {
            consent.ad_storage = 'granted';
        }

        if (typeof gtag === 'function') {
            gtag("consent", "update", consent);
        }
    }

    getCookie(cname) {
        let name = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    closeModal() {
        this.$uibModalInstance.dismiss('');
    }
}

let cookieWallComponent = {
    bindings: {},
    controller: CookieWallController
};

export default cookieWallComponent;
